import { Box } from "@mui/material";
import { useClient } from "../../hooks/Client";

const LoadingLogo = () => {
    const { client } = useClient();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100%',
            }}
        >
            <Box
                component="img"
                src={client.logo}
                alt={`${client.name} Logo`}
                sx={{
                    width: '200px',
                    height: 'auto',
                    animation: 'pulse 2s ease-in-out infinite',
                    '@keyframes pulse': {
                        '0%, 100%': {
                            opacity: 0.6,
                            transform: 'scale(1)',
                        },
                        '50%': {
                            opacity: 1,
                            transform: 'scale(1.05)',
                        },
                    },
                }}
            />
        </Box>
    );
};

export default LoadingLogo;
